import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { sum } from 'lodash';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-dropdown-selection',
  templateUrl: './dropdown-selection.component.html',
  styleUrls: ['./dropdown-selection.component.scss'],
})
export class DropdownSelectionComponent implements OnInit {
  @Input() buttonToggleText = '';
  @Input() headerText = '';
  @Input() selectedItem: any = null;
  @Output() itemSearch = new EventEmitter();
  @Output() selectedItemChange = new EventEmitter();
  @ViewChild(CdkVirtualScrollViewport, ) virtualScroll: CdkVirtualScrollViewport | undefined;
  public virtualScrollMaxHeight = 205;
  public virtualScrollHeight = this.virtualScrollMaxHeight;
  public searchText!: string;
  public filteredItems: any;

  @Input() items: Observable<any[]> = of();
  @Input() isExpandedStyle = false;
  @Input() showNavigationButton = true;
  @Input() displaySearch = true;
  @Input() selectedToggleOption: any = null;
  @Input() onTrackBy: (args: any) => void = (item) => item.displayName;

  ngOnInit() {
    this.callItems();
  }

  onItemSearchChange = (searchTerm: string) => {
    this.itemSearch.emit(this.searchText);
  };

  trackByFn(_: number, item: any) {
    return item.guid;
  }

  selectItem = (item: any) => {
    this.selectedItemChange.emit(item);
    this.selectedItem = item;
  };

  callItems() {
    this.itemSearch.emit("");
    this.items.subscribe((x) => {
      this.filteredItems = x;
      this.computeVirtualScrollHeight(x);
    });
  }

  computeVirtualScrollHeight(items: any[]) {
    const maxTextLengthPerRow = 28;
    const lengthData = items.map((m) => {
      const length = m.displayName ? m.displayName.length : 28;
      const rowOccupied = Math.ceil(length / maxTextLengthPerRow);
      return (rowOccupied + 1) * 20; // +1 to add additional 20px
    });

    const totalHeight = sum(lengthData);
    this.virtualScrollHeight = totalHeight <= this.virtualScrollMaxHeight ? totalHeight : this.virtualScrollMaxHeight;
  }
}
